import { TaxUploadHistoryItem } from "../../schema/taxes.schema";
import { Box, Flex, Spinner, Table, Text } from "@chakra-ui/react";
import { AppColors } from "@/styles/colors";
import { historyScrollAreaCss } from "../../schema/custom-styles";
import dayjs from "dayjs";
import { NoDataSmall } from "@/components/common/section-components/NoDataSmall";

interface Props {
  loadingHistory: boolean;
  history: TaxUploadHistoryItem[];
  uploadTaxesHeaders: {
    label: string;
    value: string;
    align: string;
  }[];
  buildStatusBadge: (status: string) => React.ReactNode;
  getActionElements: (historyItem: TaxUploadHistoryItem) => React.ReactNode;
}

export const HistoryContent = ({
  loadingHistory,
  history,
  uploadTaxesHeaders,
  buildStatusBadge,
  getActionElements,
}: Props) => {
  if (!loadingHistory && !history.length) return <NoDataSmall />;

  return (
    <Box>
      <Table.ScrollArea borderRadius="12px" css={historyScrollAreaCss}>
        <Table.Root
          size="sm"
          striped
          stickyHeader
          borderRadius="12px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Table.Header>
            <Table.Row>
              {uploadTaxesHeaders.map((h) => (
                <Table.ColumnHeader key={h.value}>
                  <Text
                    padding="16px"
                    color={AppColors.GRAY_TEXT}
                    fontWeight={700}
                    textTransform="uppercase"
                    fontSize="12px"
                    textAlign={h.align as any}
                  >
                    {h.label}
                  </Text>
                </Table.ColumnHeader>
              ))}
              <Table.ColumnHeader>
                <Text
                  padding="16px"
                  color={AppColors.GRAY_TEXT}
                  fontWeight={700}
                  textTransform="uppercase"
                  fontSize="12px"
                  textAlign="center"
                >
                  VER
                </Text>
              </Table.ColumnHeader>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {loadingHistory ? (
              <Table.Row>
                <Table.Cell colSpan={uploadTaxesHeaders.length + 1}>
                  <Flex justifyContent="center" padding="16px">
                    <Spinner />
                  </Flex>
                </Table.Cell>
              </Table.Row>
            ) : (
              history.map((h) => (
                <Table.Row key={h.id}>
                  <Table.Cell padding="16px">
                    <Text
                      fontWeight={400}
                      fontSize="12px"
                      color={AppColors.BLACK_TEXT_SECONDARY}
                    >
                      {dayjs(h.fechaCarga).format("DD/MM/YYYY HH:mm")}
                    </Text>
                  </Table.Cell>
                  <Table.Cell padding="16px">
                    <Text
                      fontWeight={400}
                      fontSize="12px"
                      color={AppColors.BLACK_TEXT_SECONDARY}
                      truncate
                      maxWidth="170px"
                      title={h.nombreArchivo}
                    >
                      {h.nombreArchivo}
                    </Text>
                  </Table.Cell>
                  <Table.Cell padding="16px">
                    {buildStatusBadge(h.estado)}
                  </Table.Cell>
                  <Table.Cell padding="16px">
                    <Text
                      fontWeight={400}
                      fontSize="12px"
                      color={AppColors.BLACK_TEXT_SECONDARY}
                      truncate
                      maxWidth="300px"
                      title={
                        h?.errores
                          ?.map((e) => `Fila ${e.numeroFila}: ${e.detalle}`)
                          .join(", ") || "-"
                      }
                    >
                      {h?.errores
                        ?.map((e) => `Fila ${e.numeroFila}: ${e.detalle}`)
                        .join(", ")}
                      {h?.errores?.length === 0 && "-"}
                    </Text>
                  </Table.Cell>
                  <Table.Cell textAlign="center" padding="8px">
                    {getActionElements(h)}
                  </Table.Cell>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table.Root>
      </Table.ScrollArea>
    </Box>
  );
};
